module.exports = __webpack_public_path__ + "d45720d37e84cb6d5d50e1da8c1050a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/rise.png
// module id = 655
// module chunks = 47